import React, { ReactElement } from "react";

function TwoLeafIcon(): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="33.032"
      height="30"
      viewBox="0 0 33.032 30"
    >
      <g id="plant" transform="translate(0 -21.568)">
        <g
          id="Group_3344"
          data-name="Group 3344"
          transform="translate(0 21.568)"
        >
          <path
            id="Path_9974"
            data-name="Path 9974"
            d="M13.279,24.787C10.394,21.9,4.746,21.568.75,21.568a.75.75,0,0,0-.75.75c0,4,.334,9.645,3.219,12.531a6.984,6.984,0,0,0,4.936,1.763,7.479,7.479,0,0,0,5.124-1.763C15.429,32.7,15.823,27.331,13.279,24.787Z"
            transform="translate(0 -21.568)"
            fill="#68b030"
          />
          <path
            id="Path_9975"
            data-name="Path 9975"
            d="M270.1,63.765c-4,0-9.645.334-12.531,3.219-2.55,2.55-2.15,7.91,0,10.061a7.481,7.481,0,0,0,5.125,1.763,6.986,6.986,0,0,0,4.936-1.763c2.886-2.886,3.219-8.533,3.219-12.531A.75.75,0,0,0,270.1,63.765Z"
            transform="translate(-237.821 -60.798)"
            fill="#68b030"
          />
        </g>
        <path
          id="Path_9976"
          data-name="Path 9976"
          d="M95.215,131.032a.75.75,0,0,1-.75-.75c0-15.907-5.833-19.9-8.029-21.4a5.864,5.864,0,0,1-.75-.568.75.75,0,0,1,1.061-1.061,4.618,4.618,0,0,0,.537.392c1.95,1.333,6.543,4.476,8.131,14.784a17.973,17.973,0,0,1,9.867-12.268.811.811,0,0,1,1.05.332.7.7,0,0,1-.262.949l-.038.02-.121.057c-8.223,3.865-9.949,12.338-9.949,18.765A.75.75,0,0,1,95.215,131.032Z"
          transform="translate(-79.465 -79.464)"
          fill="#007a49"
        />
      </g>
    </svg>
  );
}

export default TwoLeafIcon;
